import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerModalStore } from "../stores/playerModal";
import { bonusesStore } from "../stores/bonuses";
import { bonusesAddModalStore } from "../stores/bonusesAddModal";
import { FortuneWheelStore, tournamentsBannersStore } from "../stores/tournamentsBanners";
import { bannersStore } from "../stores/tournamentsBanners";
import ProgressiveImage from "react-progressive-graceful-image";
import Poster from "../assets/poster.png";
import { BannersAddModal, bannersAddModalStore, BannersAddModalStore } from "../stores/bannersAddModal";
import tournamentsBannersEditModal from "./BannersEditModal";
import { bannersEditModalStore, BannersEditModalStore } from "../stores/tournamentsBannersEditModal";
import { tournamentsBannersAddModalStore } from "../stores/tournamentsBannersAddModal";
import { tournamentsBannersEditModalStore } from "../stores/tournamentsBannersEditModal";
/* ------- */

function createDateFromString(unixTimestamp) {
	const dateObj = new Date(unixTimestamp * 1000);


	const year = dateObj.getUTCFullYear();
	const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
	const day = String(dateObj.getUTCDate()).padStart(2, '0');


	const formattedDate = `${year}-${month}-${day}`;
	return formattedDate;
}


class TournamentsBanners extends React.Component {
	componentDidMount() {
		this.props.Interface.loadTournamentsBannerList();
	}

	render() {
		return (
			<>
				{this.props.tournamentsBanners.loaded && this.props.tournamentsBanners.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.tournamentsBanners.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.tournamentsBanners.error.code} | request timestamp: {this.props.tournamentsBanners.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.tournamentsBanners.loaded}
					columnDefinitions={[
						{ id: "name",  width: 300, header: "Name", cell: (item) =>
								<Button
									className={[this.props.styles["btn"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setTournamentsBannersEditModal({
												...this.props.tournamentsBannersEditModal,
												show: true,
												image: item.image,
												type: this.props.tournamentsBannersEditModal.currentOption.type.filter((element) => element.value === item.name.type)[0],
												name: item.name.text,
												oldName: item.name,
												badge: item.badge,
												gameID: Array.isArray(item.gameID) ? item.gameID.join(', ') : item.gameID,
												pool: item.pool,
												limit: Number(item.limit) > 0 ? "1" : "0",
												date: createDateFromString(item.date),
											});
										}, 0);
									}}
									children={item.name.text}
								/>
							 },
						{
							width: 70,
							id: "bigPoster",
							header: "image",
							cell: (item) => (
								<ProgressiveImage src={item.image} placeholder={Poster}>
									{(src) => <img style={{ width: "70px" }} src={src} alt={item.name} />}
								</ProgressiveImage>
							),
						},
						{ id: "type", header: "Name type", cell: (item) => item.name.type },
						{ id: "badge", header: "Badge", cell: (item) => item.badge },
						{ 
							id: "gameID", 
							header: "Game ID", 
							width: 150,
							cell: (item) => {
								if (!item.gameID) return "No";
								let displayValue = "";
								
								if (Array.isArray(item.gameID)) {
									displayValue = item.gameID.join(", ");
								} else {
									displayValue = String(item.gameID);
								}
								
								if (displayValue.length > 20) {
									const ids = displayValue.split(", ");
									let result = "";
									let totalLength = 0;
									
									for (let i = 0; i < ids.length; i++) {
										if (totalLength + ids[i].length + 2 > 20) {
											result += "...";
											break;
										}
										
										if (i > 0) {
											result += ", ";
											totalLength += 2;
										}
										
										result += ids[i];
										totalLength += ids[i].length;
									}
									
									return result;
								}
								
								return displayValue;
							}
						},
						{ id: "limit", header: "Limit", cell: (item) => Number(item.limit) > 0 ? 1 : 0 },
						{ id: "pool", header: "Pool", cell: (item) => <>{new Intl.NumberFormat("ru-RU").format(item.pool/100)} RUB.</>  },
						{ id: "date", header: "Date", cell: (item) => <>{new Date(item.date*1000).toLocaleDateString() + " " + new Date(item.date*1000).toLocaleTimeString()}</> },
					]}
					items={this.props.tournamentsBanners.data}
					pagination={
						<Pagination
							disabled={!this.props.tournamentsBanners.loaded}
							currentPageIndex={this.props.tournamentsBanners.pagination.current}
							pagesCount={this.props.tournamentsBanners.pagination.total}
							onChange={(page) => {
								this.props.setTournamentsBanners({ ...this.props.tournamentsBanners, pagination: { ...this.props.tournamentsBanners.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadBannerList();
								}, 250)
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
								/>
							}
						/>
					}
					header={<Box
						margin={{ bottom: "m" }}
						children={
							<Header
								children="Tournaments banners"
								counter={
									<>
										({this.props.tournamentsBanners.data.length})
									</>
								}
								actions={
									<SpaceBetween direction="horizontal" size="l">
										<Button
											disabled={!this.props.tournamentsBanners.loaded}
											className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
											onClick={() => {
												setTimeout(() => {
													this.props.setTournamentsBannersAddModal({ ...this.props.tournamentsBannersAddModal, show: true });
												}, 0);
											}}
											variant="primary"
											children="Add tournament banner"
										/>
									</SpaceBetween>
								}
							/>
						}
					/>}
					empty="No tournamentsBanners found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const tournamentsBanners = useRecoilValue(tournamentsBannersStore);
		const setTournamentsBanners = useSetRecoilState(tournamentsBannersStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const tournamentsBannersEditModal = useRecoilValue(tournamentsBannersEditModalStore);
		const setTournamentsBannersEditModal = useSetRecoilState(tournamentsBannersEditModalStore);
		const tournamentsBannersAddModal = useRecoilValue(tournamentsBannersAddModalStore);
		const setTournamentsBannersAddModal = useSetRecoilState(tournamentsBannersAddModalStore);

		return <Component {...props} tournamentsBannersEditModal={tournamentsBannersEditModal} setTournamentsBannersEditModal={setTournamentsBannersEditModal} tournamentsBannersAddModal={tournamentsBannersAddModal} setTournamentsBannersAddModal={setTournamentsBannersAddModal} tournamentsBanners={tournamentsBanners} setTournamentsBanners={setTournamentsBanners} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(TournamentsBanners);